import { post, get } from "../request";
// 发送验证码
export function sendCode(data) {
  return post("/ProxyAdmin/v1/auth/sendCode", data);
}
